import axios from "axios";

export async function getAccountTransactionCount(
  accountId: string,
  financialYear?: string,
): Promise<number | undefined> {
  return (
    await axios.get(`/accounts/${accountId}/transactions/count`, {
      params: { year: financialYear },
    })
  ).data.count;
}
